import React, {useEffect, useRef} from 'react'
import {cx} from '@emotion/css'

import {Dot, DotsWrapper} from './styles'

interface Props {
  totalImages: number
  currentIndex: number
  hotelId: string
}

export const SwipeGalleryDots: React.FC<Props> = ({
  hotelId,
  totalImages,
  currentIndex
}) => {
  const DotsRef = useRef<HTMLDivElement>(null)
  const allDots = new Array(totalImages).fill(0)

  useEffect(() => {
    if (typeof window === 'undefined') return
    if (!DotsRef.current) return

    const dot = DotsRef.current.querySelector(
      `[data-id="${hotelId}-SwipeGalleryDot-${currentIndex}"]`
    ) as HTMLElement
    if (!dot) return

    const container = DotsRef.current
    const containerWidth = container.offsetWidth
    const dotLeft = dot.offsetLeft
    const dotWidth = dot.offsetWidth
    const scrollPosition = dotLeft - containerWidth / 2 + dotWidth / 2

    container.scrollTo({
      left: scrollPosition,
      behavior: 'smooth'
    })
  }, [currentIndex])

  return (
    <DotsWrapper ref={DotsRef}>
      {allDots.map((_, index) => (
        <Dot
          key={index}
          data-id={`${hotelId}-SwipeGalleryDot-${index}`}
          className={cx(
            index === currentIndex && '--active-dot',
            index - 2 === currentIndex && '--small-dot',
            index + 2 === currentIndex && '--small-dot',
            index - 3 >= currentIndex && '--extra-small-dot',
            index + 3 <= currentIndex && '--extra-small-dot'
          )}
        />
      ))}
    </DotsWrapper>
  )
}
